import type { SVGProps } from 'react';

export function InstagramIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg fill="none" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.6667 7H21.68M7.66667 1H21C24.6819 1 27.6667 3.98477 27.6667 7.66667V21C27.6667 24.6819 24.6819 27.6667 21 27.6667H7.66667C3.98477 27.6667 1 24.6819 1 21V7.66667C1 3.98477 3.98477 1 7.66667 1ZM19.6669 13.4934C19.8315 14.6031 19.6419 15.7364 19.1253 16.7321C18.6086 17.7278 17.7911 18.5353 16.7891 19.0396C15.7871 19.544 14.6515 19.7195 13.544 19.5413C12.4364 19.3631 11.4133 18.8402 10.62 18.047C9.82682 17.2537 9.3039 16.2306 9.12568 15.123C8.94746 14.0155 9.12301 12.8799 9.62736 11.8779C10.1317 10.8759 10.9392 10.0584 11.9349 9.54173C12.9306 9.02507 14.0639 8.83553 15.1736 9.00008C16.3055 9.16792 17.3534 9.69536 18.1625 10.5045C18.9716 11.3136 19.4991 12.3615 19.6669 13.4934Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
